/**
 * Compatibility version of this web bundle. Native apps send it in `x-ota-bundle-version`, and the backend refuses
 * requests below its minimum for this app (`OTA_MIN_BUNDLE_VERSIONS` in dashboard-backend) with
 * `OTA_BUNDLE_VERSION_TOO_LOW`. The app then applies the latest OTA bundle.
 *
 * Bump it (by 1) only in a change that adapts the frontend to a backend change older bundles cannot use. Then publish
 * the bundle before the backend raises its minimum. See docs/OTA.md in dashboard-backend.
 */
export const OTA_BUNDLE_VERSION = 3;
